/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UnreadFaxCountResponse } from './UnreadFaxCountResponse';
import {
    UnreadFaxCountResponseFromJSON,
    UnreadFaxCountResponseFromJSONTyped,
    UnreadFaxCountResponseToJSON,
    UnreadFaxCountResponseToJSONTyped,
} from './UnreadFaxCountResponse';

/**
 * 
 * @export
 * @interface GetUnreadFaxCount200Response
 */
export interface GetUnreadFaxCount200Response {
    /**
     * 
     */
    data?: UnreadFaxCountResponse;
}

/**
 * Check if a given object implements the GetUnreadFaxCount200Response interface.
 */
export function instanceOfGetUnreadFaxCount200Response(value: object): value is GetUnreadFaxCount200Response {
    return true;
}

export function GetUnreadFaxCount200ResponseFromJSON(json: any): GetUnreadFaxCount200Response {
    return GetUnreadFaxCount200ResponseFromJSONTyped(json, false);
}

export function GetUnreadFaxCount200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUnreadFaxCount200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : UnreadFaxCountResponseFromJSON(json['data']),
    };
}

export function GetUnreadFaxCount200ResponseToJSON(json: any): GetUnreadFaxCount200Response {
    return GetUnreadFaxCount200ResponseToJSONTyped(json, false);
}

export function GetUnreadFaxCount200ResponseToJSONTyped(value?: GetUnreadFaxCount200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': UnreadFaxCountResponseToJSON(value['data']),
    };
}

